import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Feriado } from '../models/feriado';
import { globals } from '../globals';
import { Observable } from 'rxjs-compat';

@Injectable({
  providedIn: 'root'
})
export class FeriadoService {

  constructor(
    private http: HttpClient
  ) { }

  buscar(id: number): Observable<Feriado> {
    return this.http.get<Feriado>(globals.apiUrl + '/api/Feriado/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  consultarComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Feriado/ListaPag',
      {
        params: parametros
      });
  }

  salvar(feriado: Feriado) {
    return this.http.post(globals.apiUrl + '/api/Feriado/Salvar', feriado);
  }

  excluir(id: number) {
    return this.http.delete(globals.apiUrl + '/api/Feriado/Excluir',
      { params: new HttpParams().set('id', id.toString()) });
  }
}
